import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BarChart, Bar, CartesianGrid, YAxis, Tooltip } from 'recharts';
import { cleanFilter, updateFilter } from '../../redux/actions/filtroAction';
import ambiente from '../../config/ambienteConfig';
import Filtro from '../relatorios/Filtro';

class Sumario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pagos: [],
            pendentes: [],
        };
    }

    componentDidMount = () => {
        this.updateGrafico();
    }

    updateGrafico = async () => {
        const filtro = this.props.filtro;
        const dataFormatada = filtro.data.format('YYYYMM');
        const query = filtro.filtroMensal? `?mes=${dataFormatada}` : '';
        const res = await axios.get(`${ambiente.dev.server}/relatorios/sumario${query}`);
        this.setState({ pagos: [res.data.pago], pendentes: [res.data.pendente] });
    }

    handleFiltroMensalAlterado = async () => {
        await this.props.updateFilter({ filtroMensal: !this.props.filtro.filtroMensal });
        this.updateGrafico();
    }

    handleFiltroPendentesAlterado = async () => {
        await this.props.updateFilter({ considerarPendentes: !this.props.filtro.considerarPendentes });
        this.updateGrafico();
    }

    render() {
        return (
            <div>
                <Filtro data mes atualizar={this.updateGrafico} />
                <BarChart width={800} height={400} data={this.state.pagos} >
                    <YAxis />
                    <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                    <Bar dataKey="receitas" fill="#7aadff" />
                    <Bar dataKey="despesas" fill="#ffaf7a" />
                    <Bar dataKey="saldo" fill="#32ba3d" />
                    <Tooltip cursor={false}/>
                </BarChart>
                <BarChart width={800} height={400} data={this.state.pendentes} >
                    <YAxis />
                    <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                    <Bar dataKey="receitas" fill="#7aadff" />
                    <Bar dataKey="despesas" fill="#ffaf7a" />
                    <Bar dataKey="saldo" fill="#32ba3d" />
                    <Tooltip cursor={false}/>
                </BarChart>
            </div>
        );
    }
}

Sumario.propTypes = {
    updateFilter: PropTypes.func.isRequired,
    cleanFilter: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired
  };
  
  function mapStateToProps({filtro}) {
    return {
        filtro: filtro
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      updateFilter: filtro => dispatch(updateFilter(filtro)),
      cleanFilter: () => dispatch(cleanFilter())
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Sumario);


// WEBPACK FOOTER //
// ./src/components/graficos/Sumario.js